import { ERegionCode } from '../../utils/regionUtils';

export interface IPanoMeasurement {
  cameraHeight: number;
  defaultCameraStandHeight: number;
  description: string;
  measurements: any[];
  titlePicture: string;
  compass: number; 
  version: number | undefined;
  region: string; 
}

/**
 * PanoMeasurementModel class represents the pano measurement data.
 */
class PanoMeasurementModel implements IPanoMeasurement {
  cameraHeight: number;
  defaultCameraStandHeight: number;
  description: string;
  measurements: any[];
  titlePicture: string;
  compass: number;
  version: number | undefined;
  region: string;

  constructor(
    cameraHeight: number = 0,
    defaultCameraStandHeight: number = 0,
    description: string = '',
    measurements: any[] = [],
    titlePicture: string = '',
    compass: number = 0,
    version?: number,
    region: string = ERegionCode.DE, 
  ) {
    this.cameraHeight = cameraHeight;
    this.defaultCameraStandHeight = defaultCameraStandHeight;
    this.description = description;
    this.measurements = measurements;
    this.titlePicture = titlePicture;
    this.compass = compass;
    this.version = version;
    this.region = region;
  }

  static fromJSON(json: any): PanoMeasurementModel {
    return new PanoMeasurementModel(
      json.cameraHeight, 
      json.defaultCameraStandHeight, 
      json.description, 
      json.measurements, 
      json.titlePicture, 
      json.compass,
      json.version,
      json.region
    );
  }
}

export default PanoMeasurementModel;